const PERMISSION_KEY= "core:referral_transition";
const PAGE_URL = {
    REFERRAL_TRANSITION_PAGE: "/admin/core/referral-transition"
}

export {PERMISSION_KEY, PAGE_URL}

